import EmblaCarousel from "embla-carousel";
import EmblaAutoplay from "embla-carousel-autoplay";

declare global {
  interface Window {
    EmblaCarousel: typeof EmblaCarousel;
    EmblaAutoplay: typeof EmblaAutoplay;
  }
}

window.EmblaCarousel = EmblaCarousel;
window.EmblaAutoplay = EmblaAutoplay;
